<template>
  <div class="container-fluid">
    <page-header
      class="mt-4 mt-md-0 mt-sm-4"
      :page="headerConfig"
    >
      <template v-slot:customActions>
        <div class="d-flex justify-content-end h-100 align-items-end pb-3">
          <action-button
            id="btn-back"
            text="Regresar"
            i="fas fa-arrow-circle-left"
            variant="outline-success"
            @click="$router.push('/operations/public-portal/applications')"
          />
          <action-button
            id="btn-save"
            class="ml-2"
            text="Actualizar"
            i="fas fa-check"
            variant="success"
            @click="onSaveChanges"
          />
        </div>
      </template>
    </page-header>
    
    <SectionTitle title="Información del Portal a enlazar" />
    
    <ValidationObserver ref="formObserver" tag="form" novalidate>
      <div class="row">
        <div class="col-12 col-lg-4 mb-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input 
              id="input-name"
              label="Nombre del Portal:"
              v-model="name"
              maxlength="30"
              :error="errors[0]"
              custom-error-msg="El nombre del portal es requerido.">
            </custom-input>
          </validation-provider>
        </div>

        <div class="col-12 col-lg-4 mb-4">
          <custom-color-picker
            id="cp-text"
            label="Color de Fondo:"
            v-model="backgroundColor">
          </custom-color-picker>
        </div>

        <div class="col-12 col-lg-4 mb-4">
          <custom-color-picker
            id="cp-background"
            label="Color de Texto:"
            v-model="textColor">
          </custom-color-picker>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-4 mb-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input 
              v-model="order"
              id="input-order"
              type="number"
              label="Número de Orden:"
              :error="errors[0]"
              custom-error-msg="El número de orden es requerido.">
            </custom-input>
          </validation-provider>
        </div>

        <div class="col-12 col-lg-8 mb-4">
          <validation-provider v-slot="{ errors }" :rules="{ regex: urlRegexRule }">
            <custom-input 
              id="input-url"
              label="Enlace (debe comenzar con https://):"
              maxlength="150"
              v-model="url"
              :error="errors[0]"
              custom-error-msg="El enlace no es válido.">
            </custom-input>
          </validation-provider>
        </div>
      </div>
    </ValidationObserver>

    <div class="icon-selector__container">
      <div v-if="showIconList">
        <span class="data-label ml-1">Seleccione Icono:</span>
        <div class="d-flex flex-wrap">
          <div 
            class="icon-image__container m-1"
            :class="{'icon-selected': icon.id == iconSelected.id }"
            v-for="icon in icons"
            :key="icon.id"
            @click="selectIcon(icon.id)"
          >
            <img :src="icon.src" :alt="icon.name">
          </div>
        </div>
      </div>

      <div v-else class="d-flex justify-content-between align-items-center">
        <portal-card 
          :text="name"
          :url="url"
          :icon="iconSelected.src"
          :text-color="textColor"
          :background-color="backgroundColor"
        />
        
        <action-button
          id="btn-show-icons"
          text="Reemplazar icono"
          i="fas fa-undo-alt"
          variant="outline-success"
          @click="showIconList = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import { CustomColorPicker } from '@/components/common';
import PortalCard from './components/PortalCard.vue';

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { save, getEditionData } from "@/services/operations/public-portal-application";
import mixAlert from '@/mixin/alert.mixin';

const URL_REGEX = /^(https):\/\/[^\s$.?#].[^\s]*$/;

export default {
  name: 'EditApplication',
  mixins: [mixAlert],
  components: {
    PageHeader,
    ActionButton,
    SectionTitle,
    CustomInput,
    CustomColorPicker,
    ValidationObserver,
    ValidationProvider,
    PortalCard,
  },
  data() {
    return {
      headerConfig: {
        title: 'Editar Enlaces al Portal Público',
        icon: 'fas fa-calculator',
        routes: ['Operaciones', 'Manejo de Enlaces del Portal Público', 'Editar'],
      },
      name: null,
      textColor: null,
      backgroundColor: null,
      url: null,
      order: null,
      iconId: null,
      icons: [],
      showIconList: false,
      urlRegexRule: URL_REGEX
    };
  },
  computed: {
    iconSelected() {
      if (!this.iconId) return {};

      return this.icons.find(icon => icon.id == this.iconId);
    }
  },
  methods: {
    async fetchInitialData() {
      let response = await getEditionData(this.$route.params.id);
      this.name = response.data.application.name;
      this.textColor = response.data.application.textColor;
      this.backgroundColor = response.data.application.backgroundColor;
      this.url = response.data.application.url;
      this.order = response.data.application.order;
      this.iconId = response.data.application.iconId;
      
      this.icons = response.data.icons;
    },
    selectIcon(id) {
      this.iconId = id;
      this.showIconList = false;
    },
    async onSaveChanges() {
      const isValid = await this.$refs.formObserver.validate();

      if (!isValid) return;

      const payload = {
        id: parseInt(this.$route.params.id),
        name: this.name,
        textColor: this.textColor,
        backgroundColor: this.backgroundColor,
        url: this.url,
        order: parseInt(this.order),
        iconId: parseInt(this.iconId),
      };

      await save(payload);
      this.ShowToast('', 'Informacion del enlace actualizada.', 'success');
    }
  },
  async mounted() {
    await this.fetchInitialData();
  }
};
</script>

<style>
.icon-selector__container {
  padding: 30px;
  border-radius: 3px;
  background-color: #f4f6f3;
  margin-top: 50px;
}


.icon-image__container {
  height: 60px;
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #b5c3bc;
  padding: 10px;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}

.icon-image__container:hover {
  box-shadow: 1px 1px 10px 3px v-bind(textColor);
}

.icon-selected {
  background-color: v-bind(textColor);
  box-shadow: none !important;
}
</style>